// extracted by mini-css-extract-plugin
module.exports = {"vUiHueDark":"#ccc","vBlue":"#107ef1","drop-zone":"ListContainer__drop-zone___i6Zsz","isOver":"ListContainer__isOver___m6PdF","label":"ListContainer__label___vSlZ7"};